import { render, staticRenderFns } from "./HwadzanGardenStaff.vue?vue&type=template&id=51e4eee9&"
import script from "./HwadzanGardenStaff.vue?vue&type=script&lang=js&"
export * from "./HwadzanGardenStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports